import { createSelector } from 'reselect'

import * as SelectorUtils from './utils'
import { DefaultUMapTopicPlanState } from '../reducers/umap_reducer'
import { DefaultFilters } from '../reducers/topics_reducer'
import { DefaultUMapTopicPlanFilteredState } from '../reducers/umap_reducer'

import TopicHelpers from '../classes/TopicHelpers'

/** Reformat the uMapPlan details for use in the umap */
function reformatRecommendations (recommendations) {
  const recos = recommendations.map((recommendation, index) => {
    const r = recommendation.recommendation
    return {
      row_id: index+1,
      topic_id: r.id,
      topic_type: TopicHelpers.topicTypeFromDetails(r),
      topic_subtype: TopicHelpers.topicSubTypeFromDetails(r),
      topic_name: r.is_video ? r.title : r.display_name || r.name,
      topic_search_name: r.is_video ? r.title : r.name,
      channel_platform_assigned_id: r.channel_platform_assigned_id,
      channel_name: r.channel_name,
      platform_assigned_id: r.platform_assigned_id,
      score: recommendation.score
    }
  })
  return recos
}

const getTopicId = (state) => {
  return state.uMap.selectedTopic
}

/* Fetches the topics byId state */
const getTopicsById = (state) => {
  return state.uMap.byId
}

const getGenreDemoSummary = (state) => {
  return state.uMap.genreDemoSummary
}

const makeGenreDemoSummarySelector = () => {
  return createSelector(
    [getGenreDemoSummary],
    (genreDemo) => {
      return genreDemo
    }
  )
}

const makeUMapTopicPlanRootSelector = () => {
  return createSelector(
    [getTopicId, getTopicsById],
    (topicId, topicsById) => {
      return (topicsById[topicId] || {}).uMapPlan
    }
  )
}

const makeUMapTopicPlanSelector = () => {
  const getUMapTopicPlan = makeUMapTopicPlanRootSelector()
  return createSelector(
    [getUMapTopicPlan],
    (topicPlan) => {
      return topicPlanSelector(topicPlan)
    }
  )
}

const topicPlanSelector = (topicPlan) => {
  let uMapPlan = { ...DefaultUMapTopicPlanFilteredState }
  let planFilters = DefaultFilters
  if (topicPlan) {
    let defaultFiltersPlan = topicPlan[DefaultFilters]
    if (defaultFiltersPlan) {
      uMapPlan = defaultFiltersPlan
      planFilters = DefaultFilters
    }
  }
  const currentPage = uMapPlan.currentPage
  const endOfResult = uMapPlan.endOfResult
  let isFetching = false
  let error = null
  let details = null
  const recos = { recommendations: [] }
  const pages = Array(currentPage).fill().map((_, index) => index + 1)
  pages.forEach(page => {
    const pagePlan = uMapPlan[page] || { ...DefaultUMapTopicPlanState }
    const pageRecos = (pagePlan.details || {}).recommendations || []
    isFetching = isFetching || SelectorUtils.isFetching(pagePlan)
    error = error || pagePlan.error
    const uniqueIds = new Set()
    const mergedRecos = recos.recommendations.concat(pageRecos)
    const uniqueRecos = mergedRecos.filter(reco => {
      const isNew = !uniqueIds.has(reco.recommendation.id)
      uniqueIds.add(reco.recommendation.id)
      return isNew
    })
    recos.recommendations = uniqueRecos
  })
  const filteredRecos = recos.recommendations
  details = {
    recommendations: reformatRecommendations(filteredRecos)
  }
  return {
    currentPage,
    endOfResult,
    isFetching,
    planFilters,
    error,
    details: details
  }
}

// -----------------------------------------------------------------------------

// Exports

// -----------------------------------------------------------------------------

export {
  makeUMapTopicPlanSelector,
  makeGenreDemoSummarySelector
}
